import { useDocument } from '@/shared/firebase/hooks/useDocument'
import { Client } from '@monorepo/functions/src/types/client'

export function useClient(id: string) {
    console.log('id', id)
    const {
        document: client,
        setDocumentSync,
        setDocument,
        isLoading,
    } = useDocument<Client>({
        collectionName: 'clients',
        id,
    })

    return {
        client,
        setClientSync: setDocumentSync,
        setClient: setDocument,
        isLoading,
    }
}
